<template>
<div class="surveillance-establishment-modal">
  <modal v-model="establishmentModal"
         :footer="false"
         :z-offset="-100"
         :header="false">
      <div v-if="establishmentModal"
           class="establishment-modal">
        <div class="establishment-div-with-padding">
          <h3>
            {{ surveillance.establishment.name }}
          </h3>
          <div v-if="conventionReceived && currentYear">
            <div class="form-group">
              <c-checkbox v-model="reset" type="bactADI" size="sm">
                Réinitialiser la charte
              </c-checkbox>
            </div>
            <alert type="info">
              <h4>Attention !</h4>
              <p>
                Modifier l'établissement de cette inscription amènera sur une
                autre charte d'engagement (celle du nouvel établissement). Si
                vous souhaitez la sauvegarder avant de modifier le responsable,
                cliquez sur le bouton ci-dessous
              </p>
              <p>
                <btn type="default"
                     @click="downloadConvention()">
                  Télécharger la charte
                </btn>
              </p>
              <save-blob :target="convention"></save-blob>
            </alert>
          </div>
          <div class="form-group">
            <sui-finess @error="setFinessError"
                        @result="setFinessResult"
                        :disabled="busy"
                        :initialFiness="finess"/>
            <sui-error-panel :error="finessError" v-if="finessError.error">
            </sui-error-panel>
            <div v-if="result != null">
              <div class="form-group"
                   v-for="(v, k) in { name: 'RAISON SOCIALE', address: 'ADRESSE' }"
                   :key="k">
                <label for="name" class="control-label">{{v}}</label>
                <input id="name"
                       class="form-control"
                       v-model="result[k]"
                       disabled="true">
              </div>
            </div>
            <btn type="warning"
                     :disabled="busy || result == null"
                     @click.once="askForConfirm">
                  Changer
                </btn>
          </div>
        </div>
      </div>
  </modal>
</div>
</template>

<script>
import assert from '@/sui/tools/assert'
import { confirm } from '@/sui/tools/modal'
import go from '@/gojs/go'
import saveBlob from '@/sui/components/saveblob'
import checkbox from '@/sui/components/checkbox'
import suiFiness from '@/sui/components/establishment/finess'
import suiErrorPanel from '@/sui/components/errorpanel'
import Error from '@/sui/tools/error'

export default {
  name: 'surveillance-establishment-modal',

  props: {
    surveillance: Object,

    value: {
      type: Boolean,
      required: true
    },

    nested: {
      type: Boolean,
      default: false
    }
  },

  created () {
  },

  data () {
    return {
      establishmentModal: this.value,
      finess: '',
      result: null,
      busy: false,
      convention: null,
      reset: true,
      finessError: new Error()
    }
  },

  computed: {
    conventionReceived: function () {
      return this.surveillance != null && this.surveillance.cvt.stat !== ''
    },

    currentYear: function () {
      return go.date.currentYear === this.surveillance.year
    }
  },

  watch: {
    establishmentModal: {
      handler: function () {
        this.$emit('input', this.establishmentModal)
        if (!this.establishmentModal) {
          this.result = null
          this.text = ''
        }
      },
      deep: true
    },

    value: function (value) {
      this.establishmentModal = value
    }
  },

  methods: {
    setFinessError: function (fe) {
      this.finessError = fe
    },

    setFinessResult: function (fr) {
      this.result = fr
    },

    askForConfirm: function () {
      const v = this.result
      const { finess, name } = this.surveillance.establishment
      const oldEtb = `${finess} - ${name}`
      const newEtb = `${v.finess} - ${v.name}`
      confirm(
        this,
        `Êtes-vous sûr.e de vouloir déplacer l'inscription
depuis l'établissement <strong>${oldEtb}</strong> vers l'établissement
<strong>${newEtb}</strong> ?`
      ).then(() => {
        this.updateEstablishment(oldEtb, newEtb)
      }).catch(() => {})
    },

    updateEstablishment: function (oldEtb, newEtb) {
      assert.notNull(this.result)

      const vm = this
      if (this.surveillance.year === 2019) {
        vm.$notify({
          type: 'danger',
          title: 'Erreur !',
          duration: 0,
          content: `Cette fonctionnalité n'est pas disponible pour
les inscriptions 2019.`
        })
        return
      }

      const request = {
        id: this.surveillance.id,
        etab: this.result.target,
        year: this.surveillance.year,
        resc: this.currentYear && this.reset
      }

      this.busy = true
      this.$store.dispatch('surveillances/updateEstablishment', request).then(
        function (response) {
          if (response.data.err != null) {
            const error = response.data.err === '[AlreadyPresent]'
              ? `L'établissement ${newEtb} est déjà inscrit à la surveillance ${request.year}.`
              : response.data.err
            vm.$notify({
              type: 'danger',
              title: 'Erreur !',
              duration: 0,
              content: `Une erreur est survenue pendant la mise à jour de
l'établissement : ${error}.`
            })
          } else {
            vm.$notify({
              type: 'success',
              title: 'Succès !',
              content: `L'inscripiton de l'établissement ${oldEtb} a bien
été déplacée vers l'établissement ${newEtb}.`
            })
          }
          vm.busy = false
          vm.establishmentModal = false
        }
      ).catch(
        function (e) {
          vm.$notify({
            type: 'danger',
            title: 'Erreur !',
            duration: 0,
            content: `Une erreur est survenue pendant la mise à jour de
l'établissement : ${e.toString()}.`
          })
          vm.busy = false
          vm.establishmentModal = false
        }
      )
    },

    downloadConvention: function () {
      let request = {
        id: this.surveillance.id
      }

      const year = this.surveillance.year
      let target = {
        filename: `SPIADI${year} - Charte - ${this.surveillance.establishment.name}.pdf`,
        blob: null
      }
      this.$store.dispatch('surveillances/downloadConvention', request).then(
        response => {
          target.blob = new Blob([response.data], { type: 'application/pdf' })
          this.convention = target
        }
      )
    }
  },

  components: {
    'save-blob': saveBlob,
    'c-checkbox': checkbox,
    'sui-finess': suiFiness,
    'sui-error-panel': suiErrorPanel
  }
}
</script>

<style lang="less">
.establishment-modal {
    .establishment-div-with-padding {
        margin-bottom: 4rem;
    }
    .input-label {
        min-width: 15rem;
    }
}
</style>
